var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36365 12.4935L1 17.0909V22.4546H17.8572V17.0909L12.4935 12.4935",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.026 5.59741C14.026 3.05833 11.9677 1 9.42859 1C6.88951 1 4.83118 3.05833 4.83118 5.59741V8.66235C4.83118 11.2014 6.88951 13.2598 9.42859 13.2598C11.9677 13.2598 14.026 11.2014 14.026 8.66235V5.59741Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83118 6.36371C5.45183 6.24111 6.25637 6.0189 7.12988 5.59747C8.14898 5.10708 8.90755 4.53241 9.42859 4.065",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.026 6.36365C13.0452 6.49391 11.7273 6.57053 10.1948 6.36365C8.96885 6.19508 7.93443 5.89624 7.12988 5.59741",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIconWhite);
export default __webpack_public_path__ + "static/media/UsersIconWhite.115259e54a3385c4d4c43877b9bb36a3.svg";
export { ForwardRef as ReactComponent };